import mainConfigs from './config'
import consoleLogger from '../../modules/console-logger'
import includeJsFile from '../../modules/include-js-file'
import uniqueArrayOfArrays from './modules/unique-array-of-arrays'
import isTestTarget from './modules/is-test-target'
import checkDisplay from './modules/check-display'
import { addCloseButton, reloader, recallEmpty } from './modules/universal-ads-functions'

const [consoleLog] = consoleLogger('Ads')

const initAds = ({
  viewportsConfig,
  forcedConfigs,
  adTargets,
  onSuccess = () => {},
  onEnableServices = () => {},
} = {}) => {
  const configs = forcedConfigs ? forcedConfigs : mainConfigs()
  if (!configs) {
    return false
  }
  viewportsConfig = viewportsConfig || configs.viewports
  window.dlab = window.dlab || {}
  window.dlab.ads = window.dlab.ads || {}

  configs.general.preloadedFiles.forEach((file) => {
    includeJsFile(file)
  })

  window.googletag = window.googletag || { cmd: [] }
  window.googletag.cmd.push(function () {
    window.callbackFunction('gptLoaded')

    const slots = configs.slots
    const sizeMappings = configs.sizeMappings
    const generalConfigs = configs.general

    if (generalConfigs.enableSingleRequest) {
      window.googletag.pubads().enableSingleRequest()
    }

    window.googletag.pubads().collapseEmptyDivs(generalConfigs.collapseEmptyDivs || true)

    adTargets = adTargets || (window.dlab && window.dlab.adTargets) || []

    if (isTestTarget()) {
      adTargets['test'] = configs.general.testValue || 'true'
    }

    for (var key in adTargets) {
      var value = adTargets[key]
      window.googletag.pubads().setTargeting(key, value.toString())
    }

    onEnableServices({ googletag: window.googletag })
    if (generalConfigs.disableInitialLoad) {
      window.googletag.pubads().disableInitialLoad()
    }
    window.googletag.enableServices()

    slots.forEach((slot) => {
      consoleLog(`div ${slot.id}`, document.getElementById(slot.id))
      if (!document.getElementById(slot.id)) return
      const sizeMappingsForSlot = sizeMappings[slot.sizeMappingName]

      let allSizes = []
      sizeMappingsForSlot.forEach((sizeMappingForSlot) => {
        allSizes.push(sizeMappingForSlot.sizes)
      })
      let flatAllSizes = allSizes.reduce((acc, val) => acc.concat(val), [])
      let distinctSizes = uniqueArrayOfArrays(flatAllSizes)

      let mapping = window.googletag.sizeMapping()
      sizeMappingsForSlot.forEach((sizeMappingForSlot) => {
        mapping.addSize(sizeMappingForSlot.viewPortSize, sizeMappingForSlot.sizes)
      })
      mapping = mapping.build()

      var newSlot = window.googletag
        .defineSlot(slot.path, distinctSizes, slot.id)
        .defineSizeMapping(mapping)
        .addService(window.googletag.pubads())

      if (slot.globalId) {
        window.window[slot.globalId] = newSlot
      }

      window.dlab.ads[slot.id] = newSlot

      window.googletag.display(slot.id)
    })

    // Resize Part
    if (viewportsConfig) {
      let size = checkDisplay(viewportsConfig)
      window.addEventListener('resize', function () {
        const newSize = checkDisplay(viewportsConfig)
        if (size != newSize) {
          size = newSize
          window.googletag.pubads().refresh()
        }
      })
    }

    if (generalConfigs.reloader) {
      reloader(generalConfigs.reloader)
    }

    if (generalConfigs.addCloseButton) {
      addCloseButton(generalConfigs.addCloseButton)
    }

    onSuccess()
  })
}

const destroyAdSettings = () => {
  window.googletag = window.googletag || { cmd: [] }
  window.googletag.cmd.push(function () {
    window.googletag.pubads().clearTargeting()
    window.googletag.destroySlots(window.googletag.pubads().getSlots())
    if (window.dlab && window.dlab.ads) {
      window.dlab.ads = {}
    }
    consoleLog('dlab ads deleted', window.dlab.ads)
    consoleLog('google ads DESTROYED', window.googletag.pubads().getSlots())
  })
}

export { initAds, destroyAdSettings }
